// Songs for the moon player, in play order. `id` is the YouTube video id.
export const SONGS = [
  { id: 'q74fX9CnqtQ', title: 'i really want to stay at your house', artist: 'rosa walton & hallie coggins' },
  { id: '0QJ5V31DISc', title: '夜風', artist: 'lamp' },
  { id: 'FJuOEuvMAnE', title: 'coffee', artist: 'bts' },
  // TODO: add DtMF once there's a specific video link
  { id: 'clKTmLWlXHE', title: "baby don't go", artist: 'dynamicduo ft. lydia paek' },
];
